export default __webpack_public_path__ + "4dfe840b9808fd9590bfcb159e7fc8d2.svg";